import React from 'react';
import './Dropdowns.css';

export default (props) => {

	return (
		<div className="dropdown">
			{
				props.selectLabelHeader ?
					<p className="dropdownsTypeHeader">{props.selectLabel}</p>
					:
					""
			}
			{

				props.form ?
					<select className={props.filterClassName} onChange={props.onChange} value={props.defaultValue} name={props.name} type="select">
						<option value="">Select a {props.placeholderName}</option>
						{
							props.items.length > 0 ?
								props.items.map((item, i) => {

									return (
										<option key={i} value={parseInt(item.id, 10)} name={item.name} >{item.name}</option>
									);
								})
								:
								<option>No Options</option>
						}
					</select>
					:
					<select value={props.defaultValue} className={props.filterClassName} onChange={(e) => { props.onChange(e.currentTarget.selectedOptions[0].value); }}>
						<option value="" >Select a {props.selectLabel}</option>
						{
							props.items.length > 0 ?
								props.items.map((item, i) => {
									return (
										<option key={i} value={parseInt(item.id, 10)} >{item.name}</option>
									);
								})
								:
								<option>No Options</option>
						}
					</select>
			}
		</div >
	);
};




// WEBPACK FOOTER //
// ./src/Components/Filters/Dropdowns/Dropdowns.js